import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Service class for handling Subscription.
 */
class SubscriptionService {
  /**
   * get Subscription List based on the provided request.
   *
   * @param request - The request parameters for getting a Subscription.
   * @returns A Promise that resolves to the Axios response for the update Subscription request.
   */
  // static getSubscriptionList(request: any) {
  //   return client.get("admin/subscription/get-subscription-list", request);
  // }

  static getSubscriptionList(request: any) {
    const [
      searchText,
      page,
      perPage,
      companyName,
      userName,
      status,
      startDate,
      renewDate,
      product,
    ] = request.queryKey;

    const params = new URLSearchParams();
    params.set("page", String(page || 1));
    params.set("per_page", String(perPage || 10));
    if (searchText) params.set("search_text", searchText);
    if (companyName) params.set("company_name", companyName);
    if (userName) params.set("user_name", userName);
    if (status) params.set("status", String(status));
    if (startDate) params.set("start_date", startDate);
    if (renewDate) params.set("renew_date", renewDate);
    if (product) params.set("product", product);

    return client.get(
      `admin/subscription/get-subscription-list?${params.toString()}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Retrieves the details of a Subscription based on the provided parameters.
   *
   * @param params - The parameters for retrieving the Subscription details.
   * @returns A Promise that resolves to the Axios response containing the Subscription details.
   */
  static getSubscriptionDetail(params: any) {
    return client.get("admin/subscription/get-subscription-detail", {
      params,
    });
  }

  /**
   * Retrieves the full transaction history for one licence key.
   *
   * @param params - { licence_key_id }
   * @returns A Promise that resolves to the Axios response containing the Subscription history.
   */
  static getSubscriptionHistory(params: any) {
    return client.get("admin/subscription/get-subscription-history", {
      params,
    });
  }

  /**
   * Renew Licence based on the provided request.
   *
   * @param request - The request parameters for adding a Cart.
   * @returns A Promise that resolves to the Axios response for the add Cart request.
   */
  static renewLicenceDetails(request: any) {
    return client.put("admin/subscription/renew-licence", request);
  }
}

export { SubscriptionService };
